/* eslint-disable react/jsx-no-target-blank */
import { object, string, number, bool } from "prop-types";
import React from "react";
import { getCurrencySymbol } from "../../../../../utils/helpers";
import { useSelector } from "react-redux";
// import { Link } from "react-router-dom";
//import createDOMPurify from 'dompurify'
//import { JSDOM } from 'jsdom'

const ViewDetails = ({
  job,
  section,
  matchScore,
  matchRecommendation,
  matchLoading,
  matchError,
}) => {
  const { userData } = useSelector((state) => state.auth);

  // Helper function to get color based on match score
  const getScoreColor = (score) => {
    if (score >= 80) return "#28a745"; // Green
    if (score >= 60) return "#ffc107"; // Yellow
    if (score >= 40) return "#fd7e14"; // Orange
    return "#dc3545"; // Red
  };
  // console.log("JOB", job);
  // const window = (new JSDOM('')).window
  // const DOMPurify = createDOMPurify(window)

  return (
    <div className="">
      {section === "documents" && (
        <div className="pb-5">
          {job.additional_files && job.additional_files[0] ? (
            <div className="d-flex flex-column">
              {job.additional_files.map((fileLink, index) => (
                <a
                  className="doc-link bg-primary mid-radius py-3 my-2 w-100"
                  key={index.toString()}
                  target="_blank"
                  href={fileLink}
                >
                  <b>{fileLink}</b>
                </a>
              ))}
            </div>
          ) : (
            <span>No Additional documents</span>
          )}
        </div>
      )}

      {section === "details" && (
        <div>
          {/* Match Score Section */}
          {!matchError && (matchScore !== null || matchLoading) && (
            <div
              style={{
                backgroundColor: "#f8f9fa",
                borderRadius: "8px",
                padding: "16px",
                marginBottom: "20px",
                border: "1px solid #e9ecef",
              }}
            >
              <h5 style={{ marginBottom: "12px" }}>Job Match Score</h5>
              {matchLoading ? (
                <div style={{ textAlign: "center", padding: "10px" }}>
                  <span>Calculating match score...</span>
                </div>
              ) : (
                <div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "10px",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "32px",
                        fontWeight: "bold",
                        color: getScoreColor(matchScore),
                        marginRight: "12px",
                      }}
                    >
                      {Math.round(matchScore)}%
                    </div>
                    <div style={{ flex: 1 }}>
                      <div
                        style={{
                          height: "10px",
                          backgroundColor: "#e9ecef",
                          borderRadius: "5px",
                          overflow: "hidden",
                        }}
                      >
                        <div
                          style={{
                            height: "100%",
                            width: `${matchScore}%`,
                            backgroundColor: getScoreColor(matchScore),
                            transition: "width 0.3s ease",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {/* {matchRecommendation && (
                    <p
                      style={{ margin: 0, fontSize: "14px", color: "#6c757d" }}
                    >
                      <strong>Recommendation:</strong> {matchRecommendation}
                    </p>
                  )} */}
                </div>
              )}
            </div>
          )}

          <div>
            <h5>Reports To</h5>
            <p>{job.reports_to}</p>
          </div>
          <div>
            <h5 style={{ paddingTop: "15px" }}>About the company</h5>

            <p>
              {/* <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(job.about_company) }}></span> */}
              {
                <span
                  dangerouslySetInnerHTML={{
                    __html: job.about_company || job.about_role,
                  }}
                ></span>
              }
            </p>
          </div>
          <div>
            <h5>Applicants Benefits</h5>
            <p>{job.applicant_benefit}</p>
          </div>
          {/* {job.salary ? (
            <div>
              <h5>Salary</h5>
              <p>
                {getCurrencySymbol(userData?.country)}{new Intl.NumberFormat().format(job.salary)} {job.duration}
              </p>
            </div>
          ) : (
            ""
          )} */}
          <div>
            <h5>Skills Required</h5>
            <ul className="d-flex flex-wrap mt-3">
              {job.skills_required && job.skills_required[0] && (
                <>
                  {job.skills_required.map((skill, index) => (
                    <li
                      key={index.toString()}
                      className="mr-2 py-1 px-2 mt-1 outlined"
                    >
                      {skill}
                    </li>
                  ))}
                </>
              )}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

ViewDetails.propTypes = {
  job: object.isRequired,
  section: string.isRequired,
  matchScore: number,
  matchRecommendation: string,
  matchLoading: bool,
  matchError: string,
};

export default ViewDetails;
